export const SRFStepType = {
  10010: {
    component: "10010_Step",
    label: "Product Details & Fees",
    progress: 25,
    nextStepId: 10015,
  },
  10015: {
    component: "10020_Step",
    label: "Asset Classes & Strategy",
    progress: 50,
    nextStepId: 10020,
  },
  10020: {
    component: "10030_Step",
    label: "Listing & Trading",
    progress: 75,
    nextStepId: 10100,
  },
  10100: {
    component: "10100_TermsConditions",
    label: "Termsheet Review & Final Confirmation",
    progress: 99,
  },
};

export const IssuerId = {
  SwissAssetizationAG: 470,
  SA1IssuerSpcLimited: 95,
  Expand2Issuer: 695,
};

// Minimum subscription end date window (business days from today) per SRF Lite variant.
export const MinSubscriptionEndDays = {
  bank: 7,
  pm: 14,
};

export const SrfProductType = {
  AMC: "AMC",
};

export const AssetClass = {
  CASH: 1,
  EQUITIES: 2,
  FIXED_INCOME: 3,
  FX: 4,
  COMMODITIES: 5,
  DIGITAL: 11,
};

export const SecondaryMarketType = {
  SPREAD_PCT: 1,
  FLAT_FEE: 2,
  NO_SECONDARY_MARKET: 3,
};

export const SecondaryMarketTradingFrequency = [
  {
    value: "daily",
    label: "Daily",
  },
  {
    value: "weekly",
    label: "Weekly",
  },
];

export const PaymentFeeFrequency = [
  {
    value: "quarterly",
    label: "Quarterly",
  },
];

export const SRFEndId = 999;

export const IssuerType = {
  GuernseyNonCellular: 1,
  GuernseyPCC: 2,
  GuernseyICC: 3,
  CaymanNonCellular: 5,
  CaymanSPC: 6,
  SwissAg: 7,
};
